import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { unsafeSVG as o } from '../../../../node_modules/lit-html/directives/unsafe-svg.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import { LSRecentSearchesFieldName, getRecentSearches } from '../../organisms/search-bar/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './search-form.scss.js';

const CLEAR_BUTTON_ARIA_LABEL = 'Clear search';
const closeIconSvg = `

  <svg role="presentation" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1313_29655_icon_close)"> 
      <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M4.68938 6.00005L-3.60352 -2.29285L-2.1893 -3.70706L6.09296 4.5752L13.636 -3.19643C14.0207 -3.59274 14.6538 -3.60219 15.0501 -3.21754C15.4464 -2.83288 15.4558 -2.19979 15.0712 -1.80348L7.50733 5.98957L15.3107 13.7929C15.7012 14.1835 15.7012 14.8166 15.3107 15.2072C14.9202 15.5977 14.287 15.5977 13.8965 15.2072L6.10359 7.41426L-2.1893 15.7072L-3.60352 14.2929L4.68938 6.00005Z" 
        fill="currentColor"/> 
    </g>
    <defs>
      <clipPath id="clip0_1313_29655_icon_close">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
`;
const searchIconSvg = `
  <svg role="presentation" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> 
    <path 
      fill-rule="evenodd" 
      clip-rule="evenodd" 
      d="M15 8.5C15 12.0899 12.0899 15 8.5 15C4.91015 15 2 12.0899 2 8.5C2 4.91015 4.91015 2 8.5 2C12.0899 2 15 4.91015 15 8.5ZM17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5ZM14.7929 16.2071L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L16.2071 14.7929L14.7929 16.2071Z" 
      fill="currentColor"/> 
  </svg>
`;
class SearchForm extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.showClearButton = false;
        this.searchTerm = '';
        this.componentid = '';
        this.controlsid = '';
        this.buttonDisabled = true;
        this.inputEl = null;
        this.inputWrapper = null;
        this.recentSearches = [];
        this.onSearchTermChange = (e) => {
            const { value } = e.target;
            this.showClearButton = value !== '';
            this.buttonDisabled = value === '';
            this.toggleEmptyClass();
        };
        this.onKeyDown = (e) => {
            const isEnterKey = e.key === 'Enter' || e.code === 'Enter';
            if (!isEnterKey)
                return;
            e.preventDefault();
            if (!this.buttonDisabled)
                this.submitForm();
        };
        this.clearInput = (e) => {
            e.preventDefault();
            if (!this.inputEl)
                return;
            this.inputEl.value = '';
            this.showClearButton = false;
            this.buttonDisabled = true;
            this.toggleEmptyClass();
            this.inputEl.focus();
        };
        this.handleFocus = () => { var _a; return (_a = this.inputWrapper) === null || _a === void 0 ? void 0 : _a.classList.add('focus'); };
        this.handleBlur = () => { var _a; return (_a = this.inputWrapper) === null || _a === void 0 ? void 0 : _a.classList.remove('focus'); };
    }
    toggleEmptyClass() {
        const form = this.renderRoot.querySelector('form');
        if (!form)
            return;
        form.classList.toggle('empty', this.buttonDisabled);
    }
    updateRecentSearches(searchTerm) {
        this.recentSearches.push(searchTerm);
        if (this.recentSearches.length > 3)
            this.recentSearches.shift();
        localStorage.setItem(LSRecentSearchesFieldName, JSON.stringify(this.recentSearches));
    }
    submitForm() {
        var _a, _b;
        this.updateRecentSearches((_b = (_a = this.inputEl) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '');
        this.renderRoot.querySelector('form').submit();
    }
    firstUpdated() {
        this.initAsyncSetup();
    }
    updated(changedProperties) {
        if (changedProperties.has('showClearButton') && this.showClearButton) {
            this.updateParts();
        }
    }
    async updateParts() {
        await this.setButtonParts();
    }
    async initAsyncSetup() {
        const inputId = `search-input-${this.componentid}`;
        this.inputEl = this.renderRoot.querySelector(`#${inputId}`);
        this.inputWrapper =
            this.renderRoot.querySelector('.input-wrapper');
        this.inputEl.value = this.searchTerm;
        this.showClearButton = this.searchTerm !== '';
        this.buttonDisabled = this.searchTerm === '';
        this.toggleEmptyClass();
        this.recentSearches = getRecentSearches(LSRecentSearchesFieldName);
        await this.setButtonParts();
    }
    static addPart(button, newPart) {
        var _a;
        if (button) {
            const currentParts = (_a = button.getAttribute('part')) !== null && _a !== void 0 ? _a : '';
            button.setAttribute('part', `${currentParts} ${newPart}`.trim());
        }
    }
    async setButtonParts() {
        var _a, _b;
        await this.updateComplete;
        const clearIconButton = this.renderRoot.querySelector('#clear-button');
        const searchIconButton = this.renderRoot.querySelector('#search-button');
        if (!searchIconButton)
            return;
        await searchIconButton.updateComplete;
        const searchButton = (_a = searchIconButton.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button');
        SearchForm.addPart(searchButton, 'search-button');
        if (!clearIconButton)
            return;
        await clearIconButton.updateComplete;
        const clearButton = (_b = clearIconButton.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('button');
        SearchForm.addPart(clearButton, 'clear-button');
    }
    renderClearInput() {
        return $ `<icon-button id="clear-button" class="search-bar-icon clear-input" styleType="${ButtonStyleTypes.OUTLINED_DARK}" @click="${this.clearInput}" aria-label="${CLEAR_BUTTON_ARIA_LABEL}"><span slot="icon" class="clear-icon">${o(closeIconSvg)}</span></icon-button><span class="button-separator"></span>`;
    }
    render() {
        const inputId = `search-input-${this.componentid}`;
        return $ `<form class="form ${this.rtl || isRTL() ? 'rtl' : ''}" action="${this.searchPageUrl}" role="search"><label class="search-title" for="${inputId}">${this.searchTitle}</label><div class="input-wrapper"><input id="${inputId}" name="q" class="search-input" type="text" aria-label="${this.searchTitle}" @keyup="${this.onSearchTermChange}" @input="${this.onSearchTermChange}" @focus="${this.handleFocus}" @blur="${this.handleBlur}" @keydown="${this.onKeyDown}" placeholder="${l(this.searchPlaceholder)}" role="combobox" aria-controls="${l(this.controlsid)}" aria-expanded="false" aria-required="true"><div class="buttons-container">${this.showClearButton ? this.renderClearInput() : null}<icon-button id="search-button" class="search-bar-icon ${this.buttonDisabled ? 'disabled' : ''}" styleType="${ButtonStyleTypes.LIGHT}" @click="${this.submitForm}" ?disabled="${this.buttonDisabled}" aria-label="${this.searchButtonText}"><span slot="icon" class="search-icon">${o(searchIconSvg)}</span></icon-button></div></div></form>`;
    }
}
SearchForm.styles = css_248z;
__decorate([
    e({ type: Boolean })
], SearchForm.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], SearchForm.prototype, "showClearButton", void 0);
__decorate([
    e({ type: String })
], SearchForm.prototype, "searchPageUrl", void 0);
__decorate([
    e({ type: String })
], SearchForm.prototype, "searchTitle", void 0);
__decorate([
    e({ type: String })
], SearchForm.prototype, "searchPlaceholder", void 0);
__decorate([
    e({ type: String })
], SearchForm.prototype, "searchButtonText", void 0);
__decorate([
    e({ type: String })
], SearchForm.prototype, "searchTerm", void 0);
__decorate([
    e({ type: String })
], SearchForm.prototype, "componentid", void 0);
__decorate([
    e({ type: String })
], SearchForm.prototype, "controlsid", void 0);
__decorate([
    t()
], SearchForm.prototype, "buttonDisabled", void 0);
customElements.define('search-form', SearchForm);

export { SearchForm };
